"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Athena = void 0;
const Tags_1 = require("../Tags");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const PlaceHazardTile_1 = require("../../deferredActions/PlaceHazardTile");
const Card_1 = require("../Card");
const CardRenderer_1 = require("../render/CardRenderer");
const Size_1 = require("../render/Size");
class Athena extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.ATHENA,
            tags: [Tags_1.Tags.EARTH],
            initialActionText: 'Place 2 hazard tiles adjacent to no other tiles.',
            startingMegaCredits: 62,
            metadata: {
                cardNumber: 'R52',
                description: 'You start with 62 M€. As your first action, place 2 hazard tiles adjacent to no other tiles.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.megacredits(62).hazardTile(1, { size: Size_1.Size.LARGE }).hazardTile(1, { size: Size_1.Size.LARGE });
                    b.corpBox('effect', (ce) => {
                        ce.vSpace(Size_1.Size.SMALL);
                        ce.effect('You do not lose production when placing adjacent to hazard tiles.', (eb) => {
                            eb.startEffect.hazardTile(1, { size: Size_1.Size.LARGE }).nbsp().asterix();
                        });
                    });
                }),
            },
        });
    }
    play() {
        return undefined;
    }
    initialAction(player) {
        const game = player.game;
        const title = 'Select space next to no other tile for hazard';
        if (game.gameOptions.aresExtension) {
            game.defer(new PlaceHazardTile_1.PlaceHazardTile(player, game, title, this.getAvailableSpaces(player, game)));
            game.defer(new PlaceHazardTile_1.PlaceHazardTile(player, game, title, this.getAvailableSpaces(player, game)));
        }
        return undefined;
    }
    getAvailableSpaces(player, game) {
        return game.board.getAvailableSpacesOnLand(player)
            .filter(((space) => space.tile === undefined))
            .filter((space) => {
            const adjacentSpaces = game.board.getAdjacentSpaces(space);
            return adjacentSpaces.filter((space) => space.tile !== undefined).length === 0;
        });
    }
}
exports.Athena = Athena;
//# sourceMappingURL=Athena.js.map